import { useSelector } from "react-redux"
import ShimmerScreen from "../../../../Layouts/ShimmerScreen"
import "./DiscussCommentReplyComponent.scss"
import { useEffect, useState } from "react"
import _ from "lodash"
import { CircularProgress } from "@mui/material"
import { useTranslation } from "react-i18next"
import { convertToEmoji } from "../../../../../utils/AppUtils"

const txtSetHeight = 32;

const DiscussCommentReplyComponent = ({
    parentCommentId, sendCommentData, isUploadingData, isShow
}) => {

    const {t} = useTranslation();
    const authData = useSelector(state => state.user.userBroker)
    const sendCmt = useSelector(state => state.discuss.sendComment)

    const [isLoading, setIsLoading] = useState(true)
    const [commentorName, setCommentorName] = useState('')
    const [commentorAvtar, setCommentorAvtar] = useState({
        imgURL: '', altText: ''
    })
    const [commentText, setCommentText] = useState('')
    const [txtAreaHgt, setTxtAreaHgt] = useState(32)
    const [allowedChar,] = useState(200)

    useEffect(() => {
        console.log('Send CommentData', sendCmt)
        if (!_.isEmpty(sendCmt)) {
            if (sendCmt.status === 'success') {
                // fetchCommentForDiscuss()
                setCommentText('')
            }
            // dispatch(postCommentDataClear())
        }
    }, [sendCmt])

    useEffect(() => {
        console.log('Parent Comment ID', parentCommentId,authData);
        if (!_.isEmpty(authData) && authData.status === 'success') {
            const payload = authData.payload.payload;
            console.log(payload)
            setCommentorName(`${payload.firstname} ${payload.lastname}`)
            const nameIntials = (payload.firstname.substr(0, 1)) + (payload.lastname ? payload.lastname.substr(0, 1) : '')
            setCommentorAvtar({
                imgURL: payload.profile_img,
                altText: nameIntials
            })
            setIsLoading(false)
        }
    }, [authData])

    const sendComment = () => {
        if (commentText) {
            console.log(commentText, parentCommentId)
            sendCommentData(commentText, parentCommentId)
        }
    }

    return (
        <div className="discuss-reply">
            <div className="avtar-logo">
                <button className="reset-btn btn-avtar">
                    {
                        isLoading ?
                            <ShimmerScreen
                                case="circle"
                                width="3rem"
                                height="3rem"
                            />
                            :
                            commentorAvtar.imgURL ?
                                <img className="" src={commentorAvtar.imgURL} alt={commentorAvtar.altText} />
                                :
                                <div
                                    className={`title-logo d-flex justify-content-center align-items-center bk-grey cursor-pointer`}
                                >
                                    <p>{commentorAvtar.altText}</p>
                                </div>
                    }
                </button>
            </div>
            <div className="reply-input">
                <div className="reply-title d-flex gap-1 align-items-center">{t('you')}
                    {
                        isLoading ?
                            <div className="d-flex gap-1">
                                (
                                <ShimmerScreen
                                    case="rect"
                                    width="2rem"
                                    height="1rem"
                                />
                                )
                            </div>
                            :
                            commentorName ?
                                <div>
                                    ({commentorName})
                                </div>
                                : ''
                    }
                </div>
                <form className="comment-form d-flex gap-1">
                    <div className="txtarea-progress position-relative">
                        {false && <div className="fileuploadbox d-flex">
                                <label htmlFor="file-upload" className={`${!isShow ? "cursor-not-allowed":"cursor-pointer"}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                                    <path opacity="0.5" d="M24.1004 12.2512L13.179 22.9525C11.8411 24.2635 10.0265 25 8.13432 25C6.24218 25 4.42754 24.2635 3.08959 22.9525C1.75165 21.6415 1 19.8634 1 18.0094C1 16.1554 1.75165 14.3773 3.08959 13.0663L14.0109 2.365C14.9029 1.491 16.1126 1 17.3741 1C18.6355 1 19.8452 1.491 20.7372 2.365C21.6292 3.23899 22.1303 4.42438 22.1303 5.6604C22.1303 6.89641 21.6292 8.0818 20.7372 8.9558L9.80401 19.6571C9.35803 20.0941 8.75314 20.3396 8.12243 20.3396C7.49172 20.3396 6.88684 20.0941 6.44086 19.6571C5.99488 19.2201 5.74433 18.6274 5.74433 18.0094C5.74433 17.3914 5.99488 16.7987 6.44086 16.3617L16.5303 6.48716" stroke="#161616" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </label>
                                <input
                                type="file"
                                id="file-upload"
                                className={`d-none`}
                                disabled={!isShow}
                            />
                        </div>}
                        <textarea
                            placeholder="Join the discussion..."
                            row="2"
                            className={`reply-box ${!isShow ? "cursor-not-allowed":""}`}
                            style={{height: `${txtAreaHgt}px`, minHeight: `${txtSetHeight}px`}}
                            value={commentText}
                            disabled={isUploadingData || !isShow}
                            onChange={(e) => {
                                console.log(e.target.value, e.target.value.length)
                                setCommentText(convertToEmoji(e.target.value))
                            }}
                            onKeyUp={(e) => {
                                const hgt = e.target.scrollHeight
                                if (hgt) {
                                    if (hgt > txtSetHeight) {
                                        setTxtAreaHgt(hgt)
                                    }
                                }
                            }}
                        />
                        {
                            isUploadingData ?
                                <button type="button" title="Send" className="send-reset-btn d-flex gap-1 align-items-center"
                                >
                                    <i className="fa fa-spinner"></i>
                                </button>
                            :
                            <button type="button" title="Send" className={`send-reset-btn d-flex gap-1 align-items-center ${!isShow ? "cursor-not-allowed":""}`}
                                onClick={() => sendComment()} disabled={!isShow}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                <path d="M24.0002 5.0722L12.3037 22.225L10.8004 12.6931L3.29717 6.62525L24.0002 5.0722Z" fill="#0F62FE" stroke="#0043CE" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.999 5.07133L10.8387 12.8269" stroke="#0043CE" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>

                        }
                        {/* <CircularProgress 
                            size="md"
                            variant="solid"
                            value={
                                commentText.length ?
                                ((commentText.length/allowedChar) * 100).toFixed(0)
                                : 100
                            }
                        >
                            {(allowedChar - commentText.length)}
                        </CircularProgress> */}
                    </div>

                </form>
            </div>
        </div>
    )
}

export default DiscussCommentReplyComponent